"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFocus = exports.scrollPreviousBladeAndFocus = exports.scrollNextBladeAndFocus = exports.getBladeBuffer = exports.getBladePostion = exports.scrollToY = void 0;
/* eslint-disable */
function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
}
/* eslint-enable */
// Smooth scroll function
var scrollToY = function (opt) {
    var _a = opt.position, position = _a === void 0 ? 0 : _a, _b = opt.duration, duration = _b === void 0 ? 300 : _b, callback = opt.callback;
    var start = window.scrollY || window.pageYOffset;
    var to = position;
    var change = to - start;
    var currentTime = 0;
    var increment = 20;
    // add animation loop
    function animateScroll() {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        window.scrollTo(0, val);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
        else if (typeof callback === 'function') {
            callback();
        }
    }
    if (duration > 0) {
        animateScroll();
    }
    else {
        window.scrollTo(0, to);
        if (callback) {
            callback();
        }
    }
};
exports.scrollToY = scrollToY;
function getBladePostion(bladeName) {
    var destinationBlade = document.querySelector(".row." + bladeName);
    if (destinationBlade === null) {
        return 0;
    }
    return destinationBlade.offsetTop;
}
exports.getBladePostion = getBladePostion;
function getBladeBuffer(destinationBlade, buffer, offset, previous) {
    // content is greater then the window height
    if (destinationBlade.clientHeight > window.innerHeight - buffer) {
        return buffer + offset;
    }
    // content + offset is greater then window height. plus 1 added as the scroll rounds down
    else if ((destinationBlade.clientHeight + offset + 1) > window.innerHeight - buffer) {
        return buffer + offset;
    }
    // content is greater then the window height + the offest on the top and bottom of the container
    else if ((destinationBlade.clientHeight + offset + offset) > window.innerHeight - buffer) {
        return buffer + offset;
    }
    //content is smaller then the window, needs to be centred.
    var topPosition = (window.innerHeight - destinationBlade.clientHeight) / 2;
    if (previous) {
        // no idea why the buffer only needs to be included in the previous. Tested multiple sizes and required everytime
        topPosition = (window.innerHeight + buffer - destinationBlade.clientHeight) / 2;
    }
    return topPosition;
}
exports.getBladeBuffer = getBladeBuffer;
function scrollNextBladeAndFocus(bladeName, buffer, offset) {
    if (buffer === void 0) { buffer = 0; }
    if (offset === void 0) { offset = 0; }
    var destinationBlade = document.querySelector(".row." + bladeName);
    if (destinationBlade === null) {
        return;
    }
    var bladeYPosition = getBladePostion(bladeName);
    var bladeBuffer = getBladeBuffer(destinationBlade, buffer, offset, false);
    var focusElement = (destinationBlade.querySelector('[tabindex="-1"]') || destinationBlade);
    ;
    // buffer could be the sticky header height
    bladeYPosition = Math.max(0, bladeYPosition - bladeBuffer);
    // Scroll to element with id
    (0, exports.scrollToY)({
        position: bladeYPosition,
        callback: function () {
            setFocus(focusElement, { preventScroll: true });
        },
    });
}
exports.scrollNextBladeAndFocus = scrollNextBladeAndFocus;
function scrollPreviousBladeAndFocus(bladeName, buffer, offset) {
    if (buffer === void 0) { buffer = 0; }
    if (offset === void 0) { offset = 0; }
    var destinationBlade = document.querySelector(".row." + bladeName);
    if (destinationBlade === null) {
        return;
    }
    var bladeYPosition = getBladePostion(bladeName);
    var bufferOffset = getBladeBuffer(destinationBlade, buffer, offset, true);
    var focusElement = (destinationBlade.querySelector('[tabindex="-1"]') || destinationBlade);
    bladeYPosition = Math.max(0, bladeYPosition - bufferOffset);
    // Scroll to element with id
    (0, exports.scrollToY)({
        position: bladeYPosition,
        callback: function () {
            //destinationBlade.focus();
            setFocus(focusElement, { preventScroll: true });
        },
    });
}
exports.scrollPreviousBladeAndFocus = scrollPreviousBladeAndFocus;
function setFocus(el, opt) {
    // for debug if page has multiple call on setting element focus
    if (opt === void 0) { opt = {}; }
    if (el && typeof el.focus === 'function') {
        el.focus(opt);
        // @ts-ignore
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;
        // @ts-ignore
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        // IE11 and Safari fix to 'prevent' window scroll after focus
        if (opt.preventScroll && (isIE || isSafari)) {
            var winPosX = window.scrollX || window.pageXOffset;
            var winPosY = window.scrollY || window.pageYOffset;
            window.scrollTo(winPosX, winPosY);
        }
    }
}
exports.setFocus = setFocus;
